import { useSelector } from 'react-redux';

import { selectFromMkadKm, selectHighwayIds } from 'shared/selectors/jsonQuery';
import { FC, useCallback, useEffect, useMemo } from 'react';
import { selectLocation } from 'shared/selectors/location';
import { useAppDispatch } from 'shared/hooks';
import { SPB_AND_REGION } from 'shared/constants/regions';
import { getRegionId } from 'shared/utils/geo';
import { selectDirectionsModal, selectNeedDirectionsDataRequest } from 'shared/selectors/geo';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { setMaxFromMkad, setMinFromMkad } from 'shared/slices/jsonQuery';
import { loadDirectionsData, removeHighways, selectHighways } from 'shared/thunks/geo/directions';
import { DirectionsV2 } from '../../../../../../packages/GeoComponents/shared/components/DirectionsModal/DirectionsV2';

export const DirectionsModalContainerV2: FC = () => {
  const dispatch = useAppDispatch();
  const fromMKAD = useSelector(selectFromMkadKm);
  const selectedHighwayIds = useSelector(selectHighwayIds);
  const { data, isLoading } = useSelector(selectDirectionsModal);
  const currentLocation = useSelector(selectLocation);
  const needDirectionsDataRequest = useSelector(selectNeedDirectionsDataRequest);

  const label = useMemo(
    () => (SPB_AND_REGION.includes(getRegionId(currentLocation)) ? 'От КАД:' : 'От МКАД:'),
    [currentLocation],
  );

  const handleMinFromMKADChange = useCallback(
    (value: number | null) => {
      dispatch(setMinFromMkad(value));
      dispatch(updateSearchMeta());
    },
    [dispatch],
  );

  const handleMaxFromMKADChange = useCallback(
    (value: number | null) => {
      dispatch(setMaxFromMkad(value));
      dispatch(updateSearchMeta());
    },
    [dispatch],
  );

  const handleHighwaysSelect = useCallback(
    (highwaysIds: number[]) => {
      dispatch(selectHighways({ highwaysIds }));
    },
    [dispatch],
  );

  const handleHighwaysDeselect = useCallback(
    (highwaysIds: number[]) => {
      dispatch(removeHighways(highwaysIds));
    },
    [dispatch],
  );

  useEffect(() => {
    if (needDirectionsDataRequest) {
      dispatch(loadDirectionsData());
    }
  }, [dispatch, needDirectionsDataRequest]);

  return (
    <DirectionsV2
      isRedesign
      fromMKAD={fromMKAD}
      isLoading={!!isLoading}
      directions={data}
      selectedHighwayIds={selectedHighwayIds}
      label={label}
      changeMaxFromMKAD={handleMaxFromMKADChange}
      changeMinFromMKAD={handleMinFromMKADChange}
      selectHighways={handleHighwaysSelect}
      deselectHighways={handleHighwaysDeselect}
    />
  );
};
